import { LicenseManager } from '../../managers/License.manager';
import { Title } from '@angular/platform-browser';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { Router } from '@angular/router';

export interface ILicenseDetailsDialogModel {
  licenseManager: LicenseManager;
}

@Component({
  selector: 'credit-card-details-dialog',
  styleUrls: ['./credit.card.details.dialog.css'],
  templateUrl: './credit.card.details.dialog.html'
})
export class CreditCardDetailsDialog extends DialogComponent<ILicenseDetailsDialogModel, boolean> implements ILicenseDetailsDialogModel, OnInit, OnDestroy {

  licenseManager: LicenseManager;
  private originalTitle: string;

  constructor(dialogService: DialogService, private titleService: Title, public router: Router) {
    super(dialogService, router);
  }
  ngOnInit() {
    this.originalTitle = this.titleService.getTitle();
    this.titleService.setTitle(this.licenseManager.newEntity.License.Key);
  }

  ngOnDestroy() {
    this.titleService.setTitle(this.originalTitle);
  }

  confirm() {
    this.licenseManager.SaveChanges();

    let saved = this.licenseManager.OnChangesSaveResponse.subscribe(response => {
      saved.unsubscribe();

      if (response.Result)
        this.closeOK();
    })
  }


  closeOK() {
    // we set dialog result as true on click on confirm button,
    // then we can get dialog result from caller code
    this.result = true;
    this.close();

  }

}
